import {
  allBaseSymbols,
  BaseSymbol,
} from '@ui/assets/config/trade-pair-listings';
import { TokenSymbol } from '@ui/constants/tokens';

export const SUPPORTED_RESOLUTIONS_CONST = [
  '1',
  '5',
  '15',
  '60',
  '240',
  '1D',
  '1W',
] as const;

export type SupportedResolution = (typeof SUPPORTED_RESOLUTIONS_CONST)[number];
export const isSupportedResolution = (
  resolution: any,
): resolution is SupportedResolution =>
  SUPPORTED_RESOLUTIONS_CONST.includes(resolution);

export type PriceCandle = {
  // timestamp in milliseconds
  time: number;
  // open price
  open: number;
  // close price
  close: number;
  // high price
  high: number;
  // low price
  low: number;
};
const BENCHMARK_SUPPORTED_BASE_SYMBOL = [...allBaseSymbols] satisfies (
  | TokenSymbol
  | BaseSymbol
)[];

export type BenchmarkSupportedBaseSymbol =
  (typeof BENCHMARK_SUPPORTED_BASE_SYMBOL)[number];

export const isBenchmarkSupportedBaseSymbol = (
  symbol: any,
): symbol is BenchmarkSupportedBaseSymbol =>
  BENCHMARK_SUPPORTED_BASE_SYMBOL.includes(symbol as any);
